import { render, staticRenderFns } from "./x-checkbox.vue?vue&type=template&id=687a9668&scoped=true&"
import script from "./x-checkbox.vue?vue&type=script&lang=js&"
export * from "./x-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./x-checkbox.vue?vue&type=style&index=0&id=687a9668&prod&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687a9668",
  null
  
)

export default component.exports